import { NamedElement, NamedElementRecord } from '@fullstory/proto/fs/services/search-settings';
import { useNotifications } from '@fullstory/react-hooks';
import { AppDispatch, fullstorySelectors, NamedElementsRequestActions } from '@fullstory/redux';
import { useSelector, useDispatch } from 'react-redux';
import {
  NAMED_ELEMENT_ARCHIVE_FAILURE,
  NAMED_ELEMENT_ARCHIVE_SUCCESS,
  NAMED_ELEMENT_SAVE_FAILURE,
  NAMED_ELEMENT_SAVE_SUCCESS,
  NAMED_ELEMENT_UNARCHIVE_FAILURE,
  NAMED_ELEMENT_UNARCHIVE_SUCCESS,
} from '../constants';
import { intl } from '@fullstory/intl';
const { getOrgId } = fullstorySelectors;

export const useNamedElementActions = () => {
  const orgId = useSelector(getOrgId);
  const dispatch = useDispatch<AppDispatch>();
  const notifications = useNotifications();

  // Save named element
  const onSave = async (
    namedElement: NamedElement,
    hasExistingIssue: boolean,
    syncPlatformsToSelectors: boolean = false,
  ) => {
    try {
      await dispatch(
        NamedElementsRequestActions.setNamedElement(
          orgId,
          namedElement,
          hasExistingIssue,
          '',
          syncPlatformsToSelectors,
        ),
      );
      notifications.success(
        intl.formatMessage({ defaultMessage: 'Successfully saved named element', id: 'ZhUb2K' }),
        NAMED_ELEMENT_SAVE_SUCCESS,
      );
    } catch (e) {
      notifications.error(
        intl.formatMessage({ defaultMessage: 'Failed to save named element', id: '0JS4Vn' }),
        NAMED_ELEMENT_SAVE_FAILURE,
      );
    }
    return undefined;
  };

  // Archive named element
  const onArchive = async (id: string): Promise<NamedElementRecord | null> => {
    try {
      const rsp = await dispatch(NamedElementsRequestActions.archiveNamedElement(orgId, id, true));
      notifications.success(
        intl.formatMessage({ defaultMessage: 'Successfully archived named element', id: 'pQlokw' }),
        NAMED_ELEMENT_ARCHIVE_SUCCESS,
      );

      return rsp.namedElement?.namedElement ?? null;
    } catch (e) {
      notifications.error(
        intl.formatMessage({ defaultMessage: 'Failed to archive named element', id: 'HlyFjB' }),
        NAMED_ELEMENT_ARCHIVE_FAILURE,
      );
    }

    return null;
  };

  // Unarchive named element
  const onUnarchive = async (id: string): Promise<NamedElementRecord | null> => {
    try {
      const rsp = await dispatch(NamedElementsRequestActions.archiveNamedElement(orgId, id, false));
      notifications.success(
        intl.formatMessage({ defaultMessage: 'Successfully unarchived page', id: '11Apjp' }),
        NAMED_ELEMENT_UNARCHIVE_SUCCESS,
      );

      return rsp.namedElement?.namedElement ?? null;
    } catch (e) {
      notifications.error(
        intl.formatMessage({ defaultMessage: 'Failed to unarchive named element', id: 'bBZMF5' }),
        NAMED_ELEMENT_UNARCHIVE_FAILURE,
      );
    }

    return null;
  };

  return {
    onSave,
    onArchive,
    onUnarchive,
  };
};
